// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Terms {
  width: 80%;
  margin-inline: auto;
  padding-top: 100px;
  margin-bottom: 100px;
}

.Terms li {
  margin-bottom: 10px;
  font-size: 16px;
}

@media (max-width: 1024px) {
  .Terms {
    padding-top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Terms.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".Terms {\r\n  width: 80%;\r\n  margin-inline: auto;\r\n  padding-top: 100px;\r\n  margin-bottom: 100px;\r\n}\r\n\r\n.Terms li {\r\n  margin-bottom: 10px;\r\n  font-size: 16px;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .Terms {\r\n    padding-top: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
